import dayjs from "dayjs";
import { sql } from "drizzle-orm";
import { customType } from "drizzle-orm/pg-core";
import { objectToCamel, objectToSnake } from "ts-case-convert";

// Using a custom type so that camelCase keys are used in application code but
// are converted to PostgreSQL standard snake_case keys in the database.
// Similar behaviour is the default for all other column types in drizzle-orm.
export const customJsonb = <TData>(name: string) =>
  customType<{ data: TData | null; driverData: TData | null }>({
    dataType: () => {
      return "jsonb";
    },
    toDriver: (value: TData | null) => {
      if (value == null) {
        return null;
      }

      const snakeCasedValue = objectToSnake(value as object);
      return sql`(((${JSON.stringify(snakeCasedValue)})::jsonb)#>> '{}')::jsonb`;
    },
    fromDriver: (value): TData | null => {
      if (value == null) {
        return null;
      }

      return objectToCamel(value as object) as TData;
    },
  })(name);

// Using a custom type to ensure ISO 8601 strings format
export const customTimestamp = customType<{
  data: string;
  driverData: string;
}>({
  dataType() {
    return "timestamp with time zone";
  },
  fromDriver(value: string): string {
    return dayjs(value).toISOString();
  },
});

// Using a custom type to ensure date string with format 'YYYY-MM-DD'
export const customDate = customType<{
  data: string;
  driverData: string;
}>({
  dataType() {
    return "date";
  },
  fromDriver(value: string): string {
    return dayjs(value).format("YYYY-MM-DD");
  },
});
